import { request } from 'utils';
import configs from 'configs';

export async function logout (params) {
  return request({
    url: configs.logoutUrl,
    method: 'get',
    data: params,
  });
}

export async function getUserProfile (params) {
  return request({
    url: configs.userProfileUrl,
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/app.js